import React from 'react';
import Draggable from 'react-draggable';
import { OmniIconComponent } from '../../../../shared/components/omni-components';
import { filter } from 'omni-ui/icon/iconset-interactive.js';

export default class PlatformFilterComponent extends React.Component {
    nodeRef = null;
    defaultState = {
        enableFilter: false,
        filterData: {
            objectName: '',
        },
    };
    constructor(props) {
        super(props);
        this.state = this.defaultState;
        this.nodeRef = React.createRef();
    }

    /**
  * Toggle the filter component visibility
  */
    toggleFilter = () => {
        this.setState({ enableFilter: !this.state.enableFilter });
    };

    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState((prev) => ({ filterData: { ...prev.filterData, [name]: value } }));
    };

    /**
     * Clear all the filter data
     */
    onClearAllFilter = () => {
        this.props.onApplyFilter({});
        this.setState(this.defaultState);
    };

    applyFilter = () => {
        this.props.onApplyFilter(this.state.filterData);
        this.toggleFilter();
    };



    render() {
        return (
            <>
                <omni-tooltip>
                    <button slot="invoker" className={`button is-text is-shadowless ${this.state.enableFilter ? 'is-active' : ''}`} onClick={this.toggleFilter}>
                        <OmniIconComponent className="is-size-2" icon-id="omni:interactive:filter" />
                    </button>
                    <span slot="content">Filters</span>
                </omni-tooltip>
                {this.state.enableFilter &&
                    <Draggable nodeRef={this.nodeRef} axis="both" bounds='body' defaultPosition={{ x: -180, y: 125 }}>
                        <div ref={this.nodeRef}>
                            <div className="platform-filter-container">
                                <div className="platform-filter-header">
                                    <span className='filter-title'>Filters</span>
                                    <OmniIconComponent onClick={this.toggleFilter} className="is-size-1 filter-close-icon" icon-id="omni:interactive:close" />
                                </div>
                                <hr className="platform-filter-divider" />
                                <div className="platform-filter-body">
                                    <button className="button clear-all-button is-text is-small" onClick={this.onClearAllFilter}>Clear All</button>
                                    <section className="platform-filter-section flex-column">
                                        <span className="field-label">Campaign</span>
                                        <input type="text" 
                                        name="objectName" 
                                        placeholder="Campaign Name" 
                                        onChange={this.handleChange}
                                        className="platform-filter-text-field" 
                                        value={this.state.filterData['objectName']} 
                                        />
                                    </section>
                                </div>
                                <hr className="platform-filter-divider" />
                                <div className="platform-filter-footer">
                                    <button className="button is-primary is-large" onClick={this.applyFilter}>Apply</button>
                                </div>
                            </div>
                        </div>
                    </Draggable>
                }
            </>
        )
    }
}